import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const GrauPoluidor = () => {
  const [grausPoluidor, setGrausPoluidor] = useState([]);
  const [filteredGrausPoluidor, setFilteredGrausPoluidor] = useState([]);
  const [tiposLicenca, setTiposLicenca] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingGrauPoluidor, setEditingGrauPoluidor] = useState(null);
  const [formData, setFormData] = useState({
    grau_poluidor: '',
    porte: '',
    grau: '',
    valor_conversao: '',
    id_tipo_licenca: '',
    ativo: true
  });

  const enrichGrauPoluidor = (grauPoluidor) => {
    const idTipo =
      grauPoluidor?.id_tipo_licenca !== null &&
      grauPoluidor?.id_tipo_licenca !== undefined
        ? Number(grauPoluidor.id_tipo_licenca)
        : null;

    const tipo = tiposLicenca.find((t) => Number(t.id) === idTipo);

    return {
      ...grauPoluidor,
      id_tipo_licenca: idTipo,
      tipo_licenca: grauPoluidor?.tipo_licenca || (tipo ? tipo.tipo_licenca : null)
    };
  };

  useEffect(() => {
    const fetchGraus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/grau-poluidor`);
        if (!response.ok) {
          throw new Error('Erro ao buscar graus poluidores');
        }
        const data = await response.json();
        setGrausPoluidor(data);
        setFilteredGrausPoluidor(data);
      } catch (error) {
        console.error('Erro ao carregar graus poluidores:', error);
      }
    };

    const fetchTiposLicenca = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/tipos-licenca`);
        if (!response.ok) {
          throw new Error('Erro ao buscar tipos de licença');
        }
        const data = await response.json();
        setTiposLicenca(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Erro ao carregar tipos de licença:', error);
        setTiposLicenca([]);
      }
    };

    fetchGraus();
    fetchTiposLicenca();
  }, []);

  useEffect(() => {
    const filtered = grausPoluidor.filter((grau) =>
      grau.grau_poluidor.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (grau.porte || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (grau.grau || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (grau.tipo_licenca || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (grau.valor_conversao !== null &&
        grau.valor_conversao.toString().includes(searchTerm))
    );
    setFilteredGrausPoluidor(filtered);
  }, [searchTerm, grausPoluidor]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      grau_poluidor: formData.grau_poluidor,
      porte: formData.porte,
      grau: formData.grau,
      valor_conversao: formData.valor_conversao === '' ? null : formData.valor_conversao,
      id_tipo_licenca: formData.id_tipo_licenca === '' ? null : Number(formData.id_tipo_licenca),
      ativo: formData.ativo
    };

    try {
      if (editingGrauPoluidor) {
        const response = await fetch(
          `${API_BASE_URL}/grau-poluidor/${editingGrauPoluidor.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar grau poluidor');
        }

        const updated = await response.json();
        setGrausPoluidor((prev) =>
          prev.map((grau) =>
            grau.id === editingGrauPoluidor.id ? enrichGrauPoluidor(updated) : grau
          )
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/grau-poluidor`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar grau poluidor');
        }

        const created = await response.json();
        setGrausPoluidor((prev) => [...prev, enrichGrauPoluidor(created)]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar grau poluidor:', error);
    }
  };

  const handleEdit = (grauPoluidor) => {
    setEditingGrauPoluidor(grauPoluidor);
    setFormData({
      grau_poluidor: grauPoluidor.grau_poluidor,
      porte: grauPoluidor.porte || '',
      grau: grauPoluidor.grau || '',
      valor_conversao:
        grauPoluidor.valor_conversao !== null
          ? grauPoluidor.valor_conversao.toString()
          : '',
      id_tipo_licenca:
        grauPoluidor.id_tipo_licenca !== null &&
        grauPoluidor.id_tipo_licenca !== undefined
          ? String(grauPoluidor.id_tipo_licenca)
          : '',
      ativo: grauPoluidor.ativo
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este grau poluidor?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/grau-poluidor/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir grau poluidor');
      }

      setGrausPoluidor((prev) => prev.filter((grau) => grau.id !== id));
    } catch (error) {
      console.error('Erro ao excluir grau poluidor:', error);
    }
  };

  const resetForm = () => {
    setFormData({
      grau_poluidor: '',
      porte: '',
      grau: '',
      valor_conversao: '',
      id_tipo_licenca: '',
      ativo: true
    });
    setEditingGrauPoluidor(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const grauAtual = grausPoluidor.find((g) => g.id === id);
    if (!grauAtual) return;

    const updatedGrau = {
      ...grauAtual,
      ativo: !grauAtual.ativo
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/grau-poluidor/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            grau_poluidor: updatedGrau.grau_poluidor,
            porte: updatedGrau.porte,
            grau: updatedGrau.grau,
            valor_conversao: updatedGrau.valor_conversao,
            id_tipo_licenca: updatedGrau.id_tipo_licenca,
            ativo: updatedGrau.ativo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do grau poluidor');
      }

      const saved = await response.json();
      setGrausPoluidor((prev) =>
        prev.map((g) => (g.id === id ? enrichGrauPoluidor(saved) : g))
      );
    } catch (error) {
      console.error('Erro ao atualizar status do grau poluidor:', error);
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Grau Poluidor</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <FaPlus />
            Cadastrar Grau
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingGrauPoluidor ? 'Editar Grau Poluidor' : 'Cadastrar Grau Poluidor'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="grau_poluidor">Descrição do Grau Poluidor *</label>
              <input
                type="text"
                id="grau_poluidor"
                value={formData.grau_poluidor}
                onChange={(e) =>
                  setFormData({ ...formData, grau_poluidor: e.target.value })
                }
                required
                maxLength={200}
                placeholder="Digite a descrição do grau poluidor"
              />
            </div>

            <div className="form-group">
              <label htmlFor="id_tipo_licenca">Tipo de Licença</label>
              <select
                id="id_tipo_licenca"
                value={formData.id_tipo_licenca}
                onChange={(e) =>
                  setFormData({ ...formData, id_tipo_licenca: e.target.value })
                }
              >
                <option value="">Selecione o tipo de licença</option>
                {tiposLicenca
                  .filter((t) => t.ativo)
                  .map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.tipo_licenca}
                    </option>
                  ))}
              </select>
            </div>

            <div className="grau-poluidor-row-3">
              <div className="form-group">
                <label htmlFor="porte">Porte Poluidor</label>
                <select
                  id="porte"
                  value={formData.porte}
                  onChange={(e) =>
                    setFormData({ ...formData, porte: e.target.value })
                  }
                >
                  <option value="">Selecione...</option>
                  <option value="MICRO">MICRO</option>
                  <option value="PEQUENO">PEQUENO</option>
                  <option value="MÉDIO">MÉDIO</option>
                  <option value="GRANDE">GRANDE</option>
                  <option value="ESPECIAL">ESPECIAL</option>
                  <option value="DISPENSA">DISPENSA</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="grau">Grau Poluidor</label>
                <select
                  id="grau"
                  value={formData.grau}
                  onChange={(e) =>
                    setFormData({ ...formData, grau: e.target.value })
                  }
                >
                  <option value="">Selecione...</option>
                  <option value="I">I</option>
                  <option value="II">II</option>
                  <option value="III">III</option>
                  <option value="N.A.">N.A.</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="valor_conversao">Valor de Conversão</label>
                <input
                  type="text"
                  id="valor_conversao"
                  value={formData.valor_conversao}
                  onChange={(e) =>
                    setFormData({ ...formData, valor_conversao: e.target.value })
                  }
                  maxLength={10}
                  placeholder="Até 10 caracteres"
                />
              </div>
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingGrauPoluidor ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar graus poluidores..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredGrausPoluidor.length} registro(s) encontrado(s)</span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Descrição</th>
                  <th>Tipo de Licença</th>
                  <th>Porte</th>
                  <th>Grau</th>
                  <th>Valor Conversão</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredGrausPoluidor.map(grau => (
                  <tr key={grau.id}>
                    <td>{grau.id}</td>
                    <td className="contexto-cell">{grau.grau_poluidor}</td>
                    <td>{grau.tipo_licenca || '-'}</td>
                    <td>{grau.porte}</td>
                    <td>{grau.grau}</td>
                    <td>{grau.valor_conversao}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={grau.ativo}
                          onChange={() => handleToggleStatus(grau.id)}
                          id={`toggle-${grau.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(grau)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(grau.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredGrausPoluidor.length === 0 && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhum grau poluidor encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo grau poluidor.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GrauPoluidor;
